<template>
    <tr>
        <th class="pb-50 w-50">
            <FeatherIcon :icon="vsIcon" class="mr-75" />
            <span class="font-weight-bold">{{ $t(vsLabel) }}</span>
        </th>
        <td class="pb-50 w-50" v-if="vsCheckbox == ''"> 
            <BFormCheckbox v-model="statusValue"  disabled /> 
        </td>

        <td class="pb-50 w-50" v-else>
            {{ vsValue }} 
            <span v-if="vsPhone=='' && vsValue"><a :href="'https://wa.me/34'+ phoneValue"><FeatherIcon icon="SendIcon" class="mr-75" /></a> </span>
        </td>

      
    </tr>
</template>

<script>
import { BCol, BFormCheckbox } from 'bootstrap-vue';
import { toRefs, ref } from '@vue/composition-api';

export default {
    components: { BCol, BFormCheckbox },
    props: ['vsIcon', 'vsLabel', 'vsValue', 'vsCheckbox', 'vsPhone' ], 
    setup(props) {

        const { vsPhone, vsValue, vsCheckbox } = toRefs(props)
        const phoneValue=ref(null)
        const statusValue=ref(null)
        if (vsPhone.value=='') {

            if (vsValue.value) {
                phoneValue.value = vsValue.value.replace(/[-\s]/g, '');
            }
        } 

        if (vsCheckbox.value=='') {
            if (vsValue.value) {
                if (vsValue.value <= 0 || vsValue===false) {
                    statusValue.value=false;
                } else {
                    statusValue.value=true;
                }
            }
        }

        return {phoneValue, statusValue}

    }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>